import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Output,
} from '@angular/core';

@Component({
  selector: 'rd-anz-tooltips',
  template: `
    <div class="empty-triangle"></div>
    <div class="outline-triangle"></div>
    <div class="tooltips-content">
      <ng-content></ng-content>

      <button
        class="focus-link mt-1 h-4 max-h-full w-4 max-w-full border-none bg-transparent p-0 hover:cursor-pointer"
        (click)="close()"
        [attr.aria-hidden]="isHidden"
        [attr.aria-label]="'modal.close' | translate">
        <rd-shared-icon iconSymbol="icon-close-tooltips"> </rd-shared-icon>
      </button>
    </div>
  `,
  styleUrls: ['./tooltips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnzTooltipsComponent {
  @HostBinding('class.rd-anz-tooltips') componentClass = true;
  @HostBinding('class.hidden') isHidden = false;
  @HostBinding('attr.role') role = 'tooltip';

  @Output() visibilityChanged: EventEmitter<{ isHidden: boolean }> =
    new EventEmitter<{ isHidden: boolean }>();

  constructor() {}

  close(): void {
    this.isHidden = true;
    this.visibilityChanged.emit({ isHidden: true });
  }

  open(): void {
    this.isHidden = false;
    this.visibilityChanged.emit({ isHidden: false });
  }
}
